import React from 'react';
import { Box } from '@wix/design-system';
import type { LayoutComponentProps } from '../../app-box.types';

export function NarrowSlimAppBox({
  appName = null,
  appIcon = null,
  appTeaser = null,
  topBadge = null,
  reviewsInfo = null,
  bottomBadge = null,
  className,
}: LayoutComponentProps) {
  return (
    <Box
      className={className}
      width="100%"
      height="100%"
      direction="vertical"
      align="space-between"
    >
      <Box direction="vertical">
        {topBadge && (
          // Zero-height relative anchor for the absolute badge only.
          // The content below must stay non-positioned so the WDS
          // ClickableCard overlay keeps capturing clicks over it.
          <Box position="relative">
            <Box position="absolute" top="-28px" left="0" zIndex="1">
              {topBadge}
            </Box>
          </Box>
        )}
        <Box gap="12px">
          <Box flexShrink={0}>{appIcon}</Box>
          <Box direction="vertical" width="100%">
            <Box direction="vertical" minWidth={0}>
              {appName}
              {appTeaser}
            </Box>
            <Box align="space-between" verticalAlign="bottom">
              {bottomBadge}
              {reviewsInfo}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
